module.exports = __webpack_public_path__ + "img/services-types.9e20068a.svg";